import React from "react";

const CustomCell = ({ value, Component }) => {
  return <Component value={value} />;
};

export default CustomCell;
